import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface PostDeescalationStaffResponsesSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Maintain a calm tone of voice and relaxed body language",
  "Reduce noise, movement, and stimulation in the environment",
  "Give the student space, but remain nearby and supportive",
  'Acknowledge their effort to calm down (e.g., "You\'re doing well calming your body")',
  "Avoid discussing the incident or applying consequences at this stage",
  "Offer comfort items if appropriate (e.g., water, tissue, sensory tool)",
  "Provide access to quiet, low-demand activities (e.g., drawing, reading)",
  "Use non-judgemental, supportive language",
  "Avoid rushing the student to talk or rejoin the group",
  'Offer simple choices or prompts (e.g., "Would you like to sit here or there?")',
  'Prepare gently for return to routine when appropriate (e.g., "Let me know when you\'re ready to come back")',
];

export const PostDeescalationStaffResponsesSection: React.FC<
  PostDeescalationStaffResponsesSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Describe appropriate staff responses at this stage:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label
        className="other-input-label"
        htmlFor="postDeescalationStaffResponsesOther"
      >
        Other:
      </label>
      <input
        type="text"
        id="postDeescalationStaffResponsesOther"
        name="postDeescalationStaffResponsesOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
